var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contactum-fields" }, [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.default_country,
            expression: "default_country"
          }
        ],
        attrs: { disabled: "" },
        on: {
          change: function($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function(o) {
                return o.selected
              })
              .map(function(o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.default_country = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          }
        }
      },
      [
        _c("option", [_vm._v(_vm._s("select country"))]),
        _vm._v(" "),
        _vm._l(_vm.countries, function(country) {
          return _c("option", { domProps: { value: country.code } }, [
            _vm._v(_vm._s(country.name))
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", { domProps: { innerHTML: _vm._s(_vm.field.help) } })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }